import React, { DragEventHandler, forwardRef, PropsWithChildren } from 'react';
import { noop } from 'lodash';
import { FileUploader, FileUploaderForward, UploadError, useFileUploader } from './FileUploader';

export const DropArea = forwardRef<FileUploaderForward, Props>(({
    className,
    onClick, onChange, onError = noop,
    onDragOver = noop, onDragLeave = noop, onDrop = noop,
    maxSize, multiple = false,
    children, accept = 'image/png, image/jpeg, image/bmp, image/heic, image/heif'
}, ref) => {

    const { upload } = useFileUploader(ref);

    const drop: DragEventHandler = event => {
        event.preventDefault();
        upload([...event.dataTransfer.files]);
        onDrop(event);
    };

    const drag: DragEventHandler = event => {
        event.preventDefault();
        onDragOver(event);
    };

    return (
        <div className={className} onClick={onClick}
            onDragOver={drag} onDragLeave={onDragLeave} onDrop={drop}>

            <form method='post' action='' encType='multipart/form-data'
                onSubmit={e => e.preventDefault()}>
                <FileUploader ref={ref}
                    accept={accept} maxSize={maxSize} multiple={multiple}
                    onError={onError} onChange={onChange} />
            </form>

            {children}
        </div>
    );
});

type Props = PropsWithChildren<{

    onChange: (files: File[]) => void;
    onError?: (errors: UploadError[]) => void;
    onDragOver?: DragEventHandler;
    onDragLeave?: () => void;
    onDrop?: DragEventHandler;
    onClick?: () => void;

    maxSize: number;
    accept?: string;
    multiple?: boolean;
    className?: string;
}>;